import { defaultTheme } from '@amzn/storm-ui';

const { blue, green, orange, red } = defaultTheme.color;

export const CustomButtonColor = {
  activeBookings: blue[700],
  createBooking: green[700],
  cancelledBooking: orange[700],
  uploadCSV: orange[600],
  cancel: red[700],
  submit: green[700],
  delete: red[700],
  activeUsers: blue[700],
  createUser: green[700],
  deletedUsers: red[700],
  next: blue[700],
  previous: orange[600],
  continue: blue[700],
  disabled: blue[500],
};
